<div class="custom-pagination">
  <!-- Only show pagination controls if we have data -->
  <div *ngIf="totalItems > 0" class="pagination-container">
    <ng-container *ngIf="showPageSizeSelector">
      <span class="page-size-label">Rows per page:</span>
      <mat-select [value]="pageSize" (selectionChange)="onPageSizeChange($event.value)" class="page-size-select">
        <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</mat-option>
      </mat-select>
    </ng-container>
    <button class="page-button" [disabled]="pageIndex === 0" (click)="changePage(pageIndex - 1)">
      <mat-icon>chevron_left</mat-icon>
    </button>
    
    <ng-container *ngFor="let page of getPageNumbers()">
      <ng-container *ngIf="page >= 0; else ellipsis">
        <button 
          class="page-button" 
          [class.active]="pageIndex === page" 
          (click)="changePage(page)">
          <!-- Show 1-indexed page numbers in the UI -->
          {{page + 1}}
        </button>
      </ng-container>
      <ng-template #ellipsis>
        <button class="page-button" disabled>...</button>
      </ng-template>
    </ng-container>
    
    <button class="page-button" [disabled]="pageIndex >= totalPages - 1" (click)="changePage(pageIndex + 1)">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  
  <!-- Show pagination info if we have data -->
  <div *ngIf="totalItems > 0 && showInfo" class="pagination-info">
    Showing {{pageIndex * pageSize + 1}} to {{mathRef.min((pageIndex + 1) * pageSize, totalItems)}} of {{totalItems}} items
  </div>
  
  <!-- Show message when no data is available -->
  <div *ngIf="totalItems === 0 && !loading && showNoDataMessage" class="no-data-message">
    {{noDataMessage}}
  </div>
</div> 